export default ({ COLORS }) => ({
  backButton: {
    color: COLORS.BLUE.NORMAL,
    fontSize: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
  },
  backIcon: {
    marginRight: '5px'
  },
  bottomMargin: {
    marginBottom: '10px'
  }
})
